import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import { getElementById } from "../util/Utils";
import { updateLabel, updateStatus } from "../tracking/FeatureTracking";
import type { TrackingLabels } from "../tracking/TrackingLabels";
import type { FeatureStatus } from "../tracking/Tracking";

const FACET_VALUE_TAG_CLASS = `find_facetValueTags__item`;
const FACET_VALUE_TAG_DESELECT_CLASS = `find_facetValueTag__deselect`;
const FACET_VALUE_TAG_DESELECT_SELECTOR = `.${FACET_VALUE_TAG_DESELECT_CLASS}`;

export class FacetValueTag {
  static readonly factory = HeurekaElementFactory.byElement("li", FACET_VALUE_TAG_CLASS, FacetValueTag);

  /*               */
  constructor(readonly facetValueTag: HTMLLIElement) {}

  /*                  */

  /*               */

  /*                       */

  /*                                                                                                         */
  get deselect(): HTMLElement | null {
    return this.facetValueTag.querySelector(FACET_VALUE_TAG_DESELECT_SELECTOR);
  }

  get tsFeatureRef(): string | undefined {
    return this.deselect?.dataset.tsFeatureRef;
  }

  get selectedValuesIds(): string[] | undefined {
    const selectedValuesIds = this.deselect?.dataset.selectedValuesIds;
    return selectedValuesIds ? JSON.parse(selectedValuesIds) : undefined;
  }

  get span(): HTMLSpanElement | null {
    return this.facetValueTag.querySelector("label span");
  }

  get title(): string | null {
    return this.span?.textContent || null;
  }

  get facetName(): string | null {
    return this.deselect?.dataset.facetName || null;
  }

  /*                                                                                 */
  get isCategoryPathFacetValueTagForm(): boolean {
    return (this.facetName === "kategorien" && !!this.facetValueTag.querySelector("form")) || false;
  }

  /*                                                */
  updateTrackingLabelsOnReferenced(
    status: FeatureStatus,
    filterMethod: TrackingLabels["san_FilterMethod"],
    facetLocation?: TrackingLabels["san_FacetLocation"],
  ) {
    /*                                                                          */
    const refs = this.selectedValuesIds || (this.tsFeatureRef && [this.tsFeatureRef]) || [];
    refs.forEach((ref) => {
      const facetValue = getElementById(ref);
      if (facetValue) {
        updateStatus(facetValue, status, 2);
        updateLabel(facetValue, "san_FilterMethod", filterMethod);
        if (facetLocation) {
          updateLabel(facetValue, "san_FacetLocation", facetLocation);
        }
      }
    });
    return this;
  }
}
